import Vue from 'vue'
import Vuex from 'vuex'
import sites from "./sites/index"
import schedules from "./schedules/index"
import forms from "./forms/index"
import work_orders from "./work_orders/index"
import purchase_requests from "./purchase_requests/index"
import auth from "./auth/index"
import ir from "./ir/index"
import insurance from "./insurance/index"
import purchase_orders from "./purchase_orders/index"
import generic from "./generic/index"
import contract from "./contracts/index"
import billing from "./billings/index"


Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        generic: generic,
        contract: contract,
        forms: forms,
        sites: sites,
        ir: ir,
        schedules: schedules,
        work_orders: work_orders,
        purchase_requests: purchase_requests,
        auth: auth,
        insurance: insurance,
        purchase_orders: purchase_orders,
        billing: billing,
    }
})


export default store
